import React from "react";
import "./styles/EvaluationHeader.scss";
import BackArrow from "../../../../components/VectorIcons/BackArrow";
import Avatar from "../../../../components/Avatar/Avatar";
import Button from "../../../../components/Button/Button";
import { useNavigate } from "react-router-dom";

const EvaluationHeader = (props) => {
  const { type, userName, isEditable } = props;
  const navigate = useNavigate();

  // A page opened directly (e.g. in a new tab) has no prior entry to go back to.
  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/atividades");
  };

  return (
    <>
      <div className="evaluationHeader">
        <div className="analistHeader">
          <button
            type="button"
            className="backButton"
            onClick={handleBack}
            aria-label="Voltar"
          >
            <BackArrow color="#FFF" />
          </button>
          <div className="aboutEvaluation">
            <span>{`${type}`}</span>
            <div className="avatar">
              {!!userName && <Avatar letter={userName.slice(0, 1)} />}
              <span>{!!userName ? userName : "Sem analista"}</span>
            </div>
          </div>
        </div>

        {isEditable && (
          <Button
            text="Salvar"
            classButton="buttonGreen"
            typeButton="submit"
            dataQA=""
            toValidate={false}
            clickEvent={() => {}}
          />
        )}
      </div>

      <div className="subHeader" />
    </>
  );
};

export default EvaluationHeader;
